import React from 'react'
import styled from 'styled-components'
import { COLOR } from '../constants/color'

const Wrapper = styled.div`
  display: block;
`

const StyledButton = styled.button`
  background: ${COLOR.green};
  color: ${COLOR.white};
  border: none;
  width: 250px;
  height: 45px;
  border-radius: 4px;
  font-size: 16px;
  text-transform: uppercase;
  font-family: 'Josefin Sans', sans-serif;
  letter-spacing: 0.8px;
  font-weight: 500;
  cursor: pointer;

  &:focus, &:hover {
    box-shadow: 0px 15px 25px -5px rgba(0,0,0,.125);
    transform: scale(1.01);
  }
    
  &:active {
    box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
    transform: scale(.98);
  }   
`

const Button = ({
  wrpStyle, btnStyle, title, ...props
}) => (
  <Wrapper style={wrpStyle}>
    <StyledButton {...props} style={btnStyle}>{title}</StyledButton>
  </Wrapper>
)

export default Button
